import classNames from "classnames";
import { FC, useId } from "react";
import { RouteComponentProps } from "react-router";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QESCheckbox } from "@app/shared/qes-standards/forms/Checkbox";

interface GenerateBodyProps extends RouteComponentProps<unknown> {
  emailOnSuccess: boolean;
  isLoading: boolean;
  onEmailOnSuccessChange: (emailOnSuccess: boolean) => void;
  onGenerateClick: () => Promise<void>;
  onReportNameChange: (reportName: string) => void;
  reportName: string;
}

const GenerateBody: FC<GenerateBodyProps> = (props: GenerateBodyProps) => {
  const reportNameId = useId();

  const isFileNameOk = props.reportName && props.reportName.length > 0 && props.reportName.length < 255;
  const hasError = !isFileNameOk;
  const emailId = useId();

  return (
    <>
      <hr />
      <div className="row">
        <div className="col-12 col-sm-6">
          <div className={classNames("form-inline align-items-center", { "has-error": hasError })}>
            <label className="me-1 col-form-label demibold" htmlFor={reportNameId}>Report Name:</label>
            <input
              type="text"
              id={reportNameId}
              className="form-control w-25"
              value={props.reportName}
              onChange={(e) => props.onReportNameChange(e.target.value)}
            />

            {isFileNameOk ? (
              <QESCheckbox
                containerClassName="ms-2 demibold"
                label={<><div className="me-2"><QesIcon iconName={QesIcons.MailV1} isDecorative /></div>Yes, please email me a link to the report when ready.</>}
                id={emailId}
                className="me-2"
                checked={props.emailOnSuccess}
                onChange={(e) => props.onEmailOnSuccessChange(e.target.checked)}
                testId="generate-outreach-body__email-when-ready"
              />
            ) : (
              <label className="ms-2 text-danger"> Invalid report name, please enter a name between 1 and 255 characters.</label>
            )}
          </div>
          <div className="form-row align-items-center mt-3">
            <div className="col-12">
              {props.isLoading ? (
                <QESButton qesTestId="generate-body_generating" qesType="primary" disabled className="me-2"><QesIcon className="qes-icon-spin mb-1 me-1" iconName={QesIcons.LoadingV1} description="Loading" /> Generating...</QESButton>
              ) : (
                <QESButton
                  qesTestId="generate-body_generate"
                  qesType="primary"
                  disabled={!isFileNameOk}
                  className="me-2"
                  onClick={props.onGenerateClick}
                >Generate</QESButton>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default GenerateBody;
